import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

interface Args {
	isBoardAccountTemplate: boolean;
}

export default class TemplatesAccountGridItemPlaceholderComponent extends Component<Args> {
	@service('navigation') declare navigationService: Service.Navigation;

	get route(): string {
		// To route on 'boards.public-templates' or 'reports.public-templates'
		return `${this.args.isBoardAccountTemplate ? 'boards' : 'reports'}.public-templates`;
	}

	get imageSrc(): string {
		// Use placeholder images: /images/placeholders/board-account-templates.svg or /images/placeholders/report-account-templates.svg or /images/placeholders/dark/board-account-templates.svg or /images/placeholders/dark/report-account-templates.svg
		return `/images/placeholders${this.navigationService.theme.isDark ? '/dark' : ''}/${this.args.isBoardAccountTemplate ? 'board' : 'report'}-account-templates.svg`;
	}

	get text(): string {
		return this.args.isBoardAccountTemplate
			? 'Browse 250+ free templates from our public template library.'
			: 'Browse for free templates from our public template library.';
	}

	@action
	transitionToPublicTemplates(): void {
		this.navigationService.transitionToRoute(this.route);
	}
	<template>
		<li
			role="button"
			class="card card--placeholder-public-template flex-item flex-item--placeholder filter-all"
			{{on "click" this.transitionToPublicTemplates}}
		>
			<div class="info">
				<div class="anti-stretch">
					<img src={{this.imageSrc}} alt />
					<span>Looking for more?</span>
					<div>{{this.text}}</div>
				</div>
			</div>
		</li>
	</template>
}
